/** NOTE: temporarily disabled

import * as Sentry from '@sentry/browser';
*/

export const checkIsValidCurrentValue = ({ current, expectedVariants }) => {
  const isValidCurrentValue = expectedVariants.includes(current);

  if (!isValidCurrentValue) {
    /** NOTE: temporarily disabled

    Sentry.captureException(
      `Current ${name} "${current}" not found in expected variants [${expectedVariants.join(
        ', ',
      )}]`,
    );
    */
    return false;
  }

  return true;
};

export const checkIsValidVariants = ({ variants, expectedVariants }) => {
  if (variants.length === 0) {
    /** NOTE: temporarily disabled

    Sentry.captureException(`Variants for ${name} are empty`);
    */
    return false;
  }

  if (!expectedVariants) {
    return true;
  }

  const isValidVariants =
    expectedVariants.every((variant) => variants.includes(variant)) &&
    expectedVariants.length === variants.length;

  if (!isValidVariants) {
    /** NOTE: temporarily disabled

    Sentry.captureException(
      `Variants for ${name} [${variants.join(
        ', ',
      )}] are different from expected [${expectedVariants.join(', ')}]`,
    );
    */
    return false;
  }

  return true;
};
